import { InsightMetric } from '@repo/types';
import { Pill } from '@repo/ui';
import c from 'classnames';
import { useMemo } from 'react';
import { calculatePills } from './helpers';
import styles from './MetricsFilters.module.css';
import useMetricsFilters from './useMetricsFilters';

type MetricsFiltersProps = {
  metrics: InsightMetric[];
};

export default function MetricsFilters({ metrics }: MetricsFiltersProps) {
  const { pills, prioritiesCount } = useMemo(
    () => calculatePills(metrics),
    [metrics],
  );
  const { currentFilters, setFilter, shouldShowAll } = useMetricsFilters();

  const topPrioritiesLabel =
    prioritiesCount === 1
      ? 'Top priority'
      : `Top ${prioritiesCount} priorities`;

  return (
    <div className={styles.filters}>
      <Pill
        key='all'
        className={c(styles.pill, shouldShowAll && styles.active)}
        label='All'
        onClick={() => setFilter('all')}
      />
      {prioritiesCount > 0 && (
        <Pill
          className={c(
            styles.pill,
            currentFilters.includes('top') && styles.active,
          )}
          label={topPrioritiesLabel}
          onClick={() => setFilter('top')}
        />
      )}
      {pills.map(pill => (
        <Pill
          key={pill.key}
          className={c(
            styles.pill,
            currentFilters.includes(pill.key) && styles.active,
          )}
          label={pill.label}
          iconNameLeft={pill.iconName}
          iconClassName={c(styles.pillIcon, styles[pill.key])}
          onClick={() => setFilter(pill.key)}
        />
      ))}
    </div>
  );
}
